require('./modules/append-after-polyfill');
import renderGuestListButton from "./modules/render-guest-list-button";
import renderBookingUnder16 from "./modules/render-booking-under-16";
import { registerPlanyoFormLoaded } from '../modules/planyo-form-callbacks';

const updateAdditionalProductsLayout = function() {
    const rateBox = document.querySelector('.wi-additional-products__rate-box');
    if (!rateBox) {
        console.error('updateAdditionalProductsLayout rateBox not found');
        return;
    }
    const res_form_buttons = document.querySelector('#res_form_buttons');
    if (!res_form_buttons) {
        console.error('updateAdditionalProductsLayout res_form_buttons not found');
        return;
    }
    // Move the rate box to just before res_form_buttons
    const rateBoxParent = rateBox.parentNode;
    rateBoxParent.removeChild(rateBox);
    res_form_buttons.parentNode.insertBefore(rateBox, res_form_buttons);

    const bookNowButton = res_form_buttons.querySelector('#submit_button');
    if (bookNowButton) {
        bookNowButton.value = "Make reservation";
        bookNowButton.classList.remove('btn');
        bookNowButton.classList.remove('btn-primary');
        bookNowButton.classList.remove('btn-lg');
        bookNowButton.classList.add('wi-btn');
        bookNowButton.classList.add('wi-btn--blue');
    }
}

// Register a handler instead of overwriting window.on_planyo_form_loaded
registerPlanyoFormLoaded(function(formLoaded = null) {
    if (formLoaded == 'additional_products_code') {
        updateAdditionalProductsLayout();
        return;
    }
    if (formLoaded !== 'reserve' && formLoaded !== 'reserve_new_step' && formLoaded !== 'user_modification') {
        return;
    }

    try {
        renderGuestListButton(formLoaded);
    } catch (error) {
        console.error('reservation-form.js renderGuestListButton error ', error);
    }

    try {
        renderBookingUnder16();
    } catch (error) {
        console.error('reservation-form.js renderBookingUnder16 error ', error);
    }

    try {
        const firstName = document.querySelector('.planyo [name="first"]')
        if (firstName) {
            firstName.setAttribute('readonly', true);
        }
        const lastName = document.querySelector('.planyo [name="last"]')
        if (lastName) {
            lastName.setAttribute('readonly', true);
        }
        const email = document.querySelector('.planyo [name="email"]')
        if (email) {
            email.setAttribute('readonly', true);
        }
    } catch (error) {
        console.error('reservation-form.js renderBookingUnder16 error ', error);
    }

});